import { createServerFn } from "@tanstack/react-start";
import { eq } from "drizzle-orm";
import z from "zod";
import { account, pendingEmailAccount, user } from "~/db/schema";
import { db } from "~/db";
import { v4 as uuidv4 } from "uuid";
const createCredentialAccountSchema = z.object({
  token: z.string(),
});

export const createCredentialAccount = createServerFn({ method: "POST" })
  .inputValidator(createCredentialAccountSchema)
  .handler(async (ctx) => {
    const { token } = ctx.data;

    const existingPendingEmailAccount =
      await db.query.pendingEmailAccount.findFirst({
        where: eq(pendingEmailAccount.token, token),
      });

    if (!existingPendingEmailAccount) {
      return { success: false, message: "No pending email account found" };
    }

    if (
      existingPendingEmailAccount.expiresAt &&
      existingPendingEmailAccount.expiresAt < new Date()
    ) {
      return { success: false, message: "Pending email account has expired" };
    }

    await db.insert(account).values({
      id: uuidv4(),
      accountId: uuidv4(),
      providerId: "credential",
      userId: existingPendingEmailAccount.userId,
      password: existingPendingEmailAccount.passwordHash,
      createdAt: new Date(),
      updatedAt: new Date(),
    });

    return { success: true };
  });
